import { graphql } from "../__generated__/gql";

export const GET_DATA_AVAILABILITY_QUERY = graphql(`
  query GetDataAvailability {
    dataAvailability {
      productClassification
      yearMin
      yearMax
    }
  }
`);

export default GET_DATA_AVAILABILITY_QUERY;
